export function Step1({ className }: { className?: string }) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="96" height="96" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 14C27 11.2386 29.2386 9 32 9H40H42H54H56H64C66.7614 9 69 11.2386 69 14V28H67V14C67 12.3431 65.6569 11 64 11H56V13C56 14.1046 55.1046 15 54 15H42C40.8954 15 40 14.1046 40 13V11H32C30.3431 11 29 12.3431 29 14V74.8621V82C29 83.6569 30.3431 85 32 85H64C65.6569 85 67 83.6569 67 82V74.8621V66.5H69V74.8621V82C69 84.7614 66.7614 87 64 87H32C29.2386 87 27 84.7614 27 82V74.8621V14ZM42 11V13H54V11H42ZM41 82C41 81.4477 41.4477 81 42 81H53C53.5523 81 54 81.4477 54 82C54 82.5523 53.5523 83 53 83H42C41.4477 83 41 82.5523 41 82Z"
        fill="black"
      />
      <path
        d="M78 56V60H58V56H56V60C56 60.5304 56.2107 61.0391 56.5858 61.4142C56.9609 61.7893 57.4696 62 58 62H78C78.5304 62 79.0391 61.7893 79.4142 61.4142C79.7893 61.0391 80 60.5304 80 60V56H78Z"
        fill="#656BBB"
      />
      <path
        d="M78 46L76.59 44.59L69 52.17V34H67V52.17L59.41 44.59L58 46L68 56L78 46Z"
        fill="#656BBB"
      />
    </svg>
  );
}
